import { createBrowserRouter, type RouteObject } from 'react-router-dom';
import App from './App';
import { LeadsPage } from './pages/LeadsPage';
import AnalysisPage from './pages/AnalysisPage';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <App />,
  },
  {
    path: '/leads',
    element: <LeadsPage />,
  },
  {
    path: '/analysis',
    element: <AnalysisPage />,
  },
];

// Create router with future flags enabled
export const router = createBrowserRouter(routes); 